import {useQuery} from '@tanstack/react-query';

import {getAdminBanner} from '../api';
import {QUERY__BANNERS} from '../queryKeys';
import {BannerDetail} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetBanner = <SelectedData = BannerDetail>(
  id: string,
  options?: QueryOptionsForOne<BannerDetail, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__BANNERS, id],
    queryFn: () => getAdminBanner(id),
    ...options,
  });
};
